import LegendColor from "./LegendColor";
import { LegendStatus } from "./LegendEnum";
import LegendText from "./LegendText";

type Props = {
  legendStatus: LegendStatus;
};

const LegendItem: React.FC<Props> = ({ legendStatus }) => {
  return (
    <div className="legend-item">
      <LegendColor legendStatus={legendStatus} />
      <LegendText legendText={legendStatus.toString()} />
    </div>
  );
};
export default LegendItem;
